import React, { Suspense } from 'react';
import styled from 'styled-components';
import CreateFormHandler from './CreateFormHandler';
import Mainnav from 'modules/Common/Components/Mainnav';
import SettingStickyHeader from './SettingStickyHeader';
import { FormListing } from './Section/FormListing';
import { useHistory } from 'react-router-dom';
import FormSummary from './FormSummary';
import { getQueryFormId } from 'modules/EmailBrowser/utils';

const Wrapper = styled.div`
  width: 100%;
  .form-detail-wrapper {
    padding: 0 64px !important;
  }
  .form-detail-createForm-wrapper {
    max-height: 100vh;
    height: calc(100vh - 220px);
    overflow-y: auto;
    padding: 0 64px !important;
    /* @media all and (max-width: 1439px) and (max-height: 729px) {
      height: calc(100vh - 220px);
    } */
    /* @media screen and (max-width: 1439px) and (max-height: 729px) {
      height: calc(100vh - 220px);
    }
    @media all and (min-width: 1440px) and (min-height: 730px) {
      padding: 140px 64px 10px 64px !important;
    }
    @media all and (min-width: 1440px) and (max-height: 729px) {
      padding: 120px 64px 10px 64px !important;
    }
    @media all and (min-height: 730px) {
      padding: 140px 64px 10px 64px !important;
    }
    @media all and (min-width: 1920px) {
      padding-bottom: 0 !important;
      height: calc(100vh - 90px) !important;
    }
    @media all and (max-width: 1280px) {
      padding-bottom: 0 !important;
    }
    @media screen and (min-width: 1281px) and (max-width: 1920px) {
      padding-bottom: 0 !important;
    }
    @media screen and (min-width: 1281px) and (max-width: 1920px) and (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 0 !important;
    } */
  }
  /* @media all and (min-height: 730px) {
    .form-detail-wrapper {
      padding: 110px 64px 10px 64px !important;
    }
  } */
  /* @media all and (min-width: 1440px) and (min-height: 730px) {
    .form-detail-wrapper {
      padding: 140px 64px 10px 64px !important;
    } */
    /* .form-detail-createForm-wrapper {
      padding: 140px 64px 10px 64px !important;
    } */
  }
  /* @media all and (min-width: 1440px) and (max-height: 729px) {
    .form-detail-wrapper {
      padding: 120px 64px 10px 64px !important;
    } */
    /* .form-detail-createForm-wrapper {
      padding: 120px 64px 0px 64px !important;
    } */
  }
  /* @media only screen and (min-width: 1920px) {
    .form-detail-wrapper {
      padding-bottom: 0 !important;
    }
  } */
  /* @media all and (max-width: 1280px) {
    .form-detail-wrapper {
      padding-bottom: 0 !important;
    }
  } */
  /* @media screen and (min-width: 1281px) and (max-width: 1920px) {
    .form-detail-wrapper {
      padding-bottom: 0 !important;
    }
  } */
  /* @media screen and (min-width: 1281px) and (max-width: 1920px) and (-webkit-device-pixel-ratio: 1.25) {
    .form-detail-wrapper {
      padding-bottom: 0 !important;
    }
  } */
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .global-custom-btn-style {
      font-size: 13px !important;
    }
    .search-input {
      font-size: 13px !important;
    }
  }
`;

interface IFormDetails {
  page: string;
  tab?: string;
  subtab?: string;
}

const FormDetails: React.FC<IFormDetails> = (props) => {
  const history = useHistory();
  const path = history.location.pathname;
  return (
    <>
      <Suspense fallback={<></>}>
        <Mainnav />
      </Suspense>
      <Suspense fallback={<></>}>
        <SettingStickyHeader />
      </Suspense>
      <Wrapper>
        <div className={path.endsWith('/create_form') ? 'form-detail-createForm-wrapper' : 'form-detail-wrapper'}>
          {path.endsWith('/create_form') ? <CreateFormHandler /> : path.includes('forms') && getQueryFormId() ? <FormSummary /> : <FormListing />}
        </div>
      </Wrapper>
    </>
  );
};

export default FormDetails;
